<template>
    <v-dialog v-model="dialog" persistent width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-card-text>Are you sure you want to remove accommodation {{huis.huis_code}} ?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" :disabled="disabled" small @click="rmHuis">Yes</v-btn>
                <v-btn color="success"      :disabled="disabled" small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                disabled: false,
                huis: {}
            }
        },
        methods: {
            open(huis_encrid) {
                
                this.$axios.post("ares/json/ares/huis/getHuisToRmHuis.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToRmHuis"
                    },
                    getHuisToRmHuis: {
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error,
                            color: "error"
                        });
                    } else {
                        this.huis = res.data.getHuisToRmHuis;
                        this.dialog = true;
                    }
                });
            },
            rmHuis() { 
                // Geen verdere interactie toestaan.
                this.disabled = true;
                this.$axios.post("ares/json/ares/huis/rmHuis.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "rmHuis"
                    },
                    rmHuis: {
                        huis_encrid: this.huis.huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                        this.disabled = false;
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.rmHuis.text,
                            color: res.data.rmHuis.color
                        });
                        // Geef de gebruiker even tijd de snackbar te lezen voordat we het window sluiten.
                        setTimeout(() => {
                                opener.location.reload(); 
                                window.close();
                            }, 
                            5000
                        );
                    }
                })
            },
        }
    }
</script>
